// store/modules/facturas.js
export default {
  namespaced: true,
  state: () => ({
    documentos: [],
    filtros: {},
    paginaActual: 1,
    porPagina: 10,
    ultimaConsulta: null,
  }),

  mutations: {
    setConsulta(state, payload) {
      state.documentos = payload.documentos;
      state.filtros = payload.filtros;
      state.paginaActual = payload.paginaActual;
      state.porPagina = payload.porPagina;
      state.ultimaConsulta = new Date();
    },
  },

  getters: {
    tieneDatos: (state) => state.documentos.length > 0,
  },
};
